import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ReasonOfAllowanceEditService } from '../../service/reason-of-allowance-edit/reason-of-allowance-edit.service';

@Component({
	selector: 'app-reason-of-allowance-edit',
	templateUrl: './reason-of-allowance-edit.component.html',
	providers: [
		ReasonOfAllowanceEditService,
		HttpModule
	]
})
export class ReasonOfAllowanceEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	reasonOfAllowance: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;

	constructor(fb: FormBuilder, private reasonOfAllowanceEditService: ReasonOfAllowanceEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.reasonOfAllowance = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.reasonOfAllowanceEditService.loadReasonOfAllowance(this.token, this.ID).subscribe(result => {
				var updateCompanyTtype = result.Result;
				this.reasonOfAllowance.setValue({
					ID: updateCompanyTtype.ID,
					Nome: updateCompanyTtype.Nome,
					Ativo: updateCompanyTtype.Ativo
				});
			})
		}, error => {
			console.log(error);
		});
	}

	editReasonOfAllowance(value: any) {
		console.log(value);
		this.reasonOfAllowanceEditService.editReasonOfAllowance(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/motivo-do-abono');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/motivo-do-abono');
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-allowance/component/reason-of-allowance-edit/reason-of-allowance-edit.component.ts